module.exports = __webpack_public_path__ + "static/media/ze-imas-svoj-stil.da0b2adf.png";